// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-color-picker__toggle {
  padding: 0 8px;
}
.n-color-picker__activeColor {
  width: 14px;
  height: 14px;
}
.n-color-picker__activeColor--inactive {
  background: var(--color-popover-background);
  border: 1px solid var(--color-border-base);
}
.n-color-picker__activeColor--color-elm {
  background-color: #1e6d71;
}
.n-color-picker__activeColor--color-green-vogue {
  background-color: #021f4e;
}
.n-color-picker__activeColor--color-orient {
  background-color: #005879;
}
.n-color-picker__activeColor--color-endeavour {
  background-color: #055fb3;
}
.n-color-picker__activeColor--color-eastern-blue {
  background-color: #138aae;
}
.n-color-picker__activeColor--color-bali-hai {
  background-color: #88a3aa;
}
.n-color-picker__activeColor--color-pelorous {
  background-color: #34b5ba;
}
.n-color-picker__activeColor--color-shamrock {
  background-color: #33cc99;
}
.n-color-picker__activeColor--color-old-gold {
  background-color: #d1ba33;
}
.n-color-picker__activeColor--color-malachite {
  background-color: #1dd65f;
}
.n-color-picker__activeColor--color-mantis {
  background-color: #87bf56;
}
.n-color-picker__activeColor--color-di-serria {
  background-color: #dd9e5f;
}
.n-color-picker__activeColor--color-tree-poppy {
  background-color: #f7931e;
}
.n-color-picker__activeColor--color-flamingo {
  background-color: #f15a24;
}
.n-color-picker__activeColor--color-roman {
  background-color: #d74d52;
}
.n-color-picker__activeColor--color-stiletto {
  background-color: #8f2c2f;
}
.n-color-picker__activeColor--color-violet-eggplant {
  background-color: #a0187d;
}
.n-color-picker__activeColor--color-dallas {
  background-color: #754c24;
}
.n-color-picker__swatches {
  padding: 8px;
  width: 136px;
}
.n-color-picker__swatch {
  margin: 2px;
  height: 16px;
  width: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/color-picker/ColorPicker.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AACE;EACE,cAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAEI;EACE,2CAAA;EACA,0CAAA;AAAN;AAIO;EACC,yBAAA;AAFR;AACO;EACC,yBAAA;AACR;AAFO;EACC,yBAAA;AAIR;AALO;EACC,yBAAA;AAOR;AARO;EACC,yBAAA;AAUR;AAXO;EACC,yBAAA;AAaR;AAdO;EACC,yBAAA;AAgBR;AAjBO;EACC,yBAAA;AAmBR;AApBO;EACC,yBAAA;AAsBR;AAvBO;EACC,yBAAA;AAyBR;AA1BO;EACC,yBAAA;AA4BR;AA7BO;EACC,yBAAA;AA+BR;AAhCO;EACC,yBAAA;AAkCR;AAnCO;EACC,yBAAA;AAqCR;AAtCO;EACC,yBAAA;AAwCR;AAzCO;EACC,yBAAA;AA2CR;AA5CO;EACC,yBAAA;AA8CR;AA/CO;EACC,yBAAA;AAiDR;AA5CE;EACE,YAAA;EACA,YAAA;AA8CJ;AA3CE;EACE,WAAA;EACA,YAAA;EACA,WAAA;AA6CJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.n-color-picker {\n\n  @active-color-size: 14px;\n  @swatches-padding: @layoutUnit-sm;\n  @swatch-size: @layoutUnit-md;\n  @swatch-margin: @layoutUnit-xxs;\n  @swatches-in-row: 6;\n\n  &__toggle {\n    padding: 0 @layoutUnit-sm;\n  }\n\n  &__activeColor {\n    width: @active-color-size;\n    height: @active-color-size;\n\n    &--inactive {\n      background: var(--color-popover-background);\n      border: 1px solid var(--color-border-base);\n    }\n\n    .forEachNamedColor({\n      &--color-@{colorName} {\n        background-color: @colorValue;\n      }\n    });\n  }\n\n  &__swatches {\n    padding: @swatches-padding;\n    width: @swatches-in-row * @swatch-size + @swatches-in-row * 2 * @swatch-margin + 2 * @swatches-padding;\n  }\n\n  &__swatch {\n    margin: @swatch-margin;\n    height: @swatch-size;\n    width: @swatch-size;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
